// /data/mock-slides-data.ts
// ✅ Mock slides data

interface Resource {
  title: string,
  subtitle?: string,
  description?: string,
  image?: string,
  href?: string,
  cta?: string,
}

export const relatedResources: Resource[] = [
    // 1
{
      title: "How To Clean Shoes",
      subtitle: "",
      description: "Get expert shoe-buying advice and learn how to choose your sneakers the right way.",
      image: "/assets/resource/ED_087_How_to_Clean_Shoes_mh_d_f0806a86f8.jpg?height=200&width=300",
      cta: "SHOP NOW",
      href: "/superstar",
    },
    {
      title: "The adidas Samba Shoe Guide",
      subtitle: "",
      description: "Discover classic adidas footwear through the fit and feel of the new and old Samba.",
      image: "/assets/resource/samba_size_guide_masthead_d_215_982556_a90150c541.jpg?height=200&width=300",
      cta: "SHOP NOW",
      href: "/superstar",
    },
    {
      title: "Are the Looks: How to Style a Tennis Skirt",
      subtitle: "",
      description: "Get inspired by iconic fashion looks to target tennis skirt outfits with adidas.",
      image: "/assets/resource/Edi_SS_24_How_to_Style_a_Tennis_Skirt_mh_d_c09648994f.jpg?height=200&width=300",
      cta: "SHOP NOW",
      href: "/superstar",
    },
    {
      title: "How to Style a Soccer Jersey",
      subtitle: "",
      description: "Get tips on how to style a soccer jersey to create a surprisingly versatile wardrobe staple.",
      image: "/assets/resource/how_to_style_a_soccer_jersey_mh_d_215_1035532_5578c26900.jpg?height=200&width=300",
      cta: "SHOP NOW",
      href: "/superstar",
    },
    // 2
{
    title: "6 Creative Ways To Lace Up Your Sneakers With Instructions",
    subtitle: "",
    description: "Take your sneaker game to the next level with our guide on how to tie shoelaces in different styles. From straight lacing to ladder lacing—we cover them all!",
    image: "/assets/resource/how_to_lace_sneakers_mh_d_221_1062527_320f9893b3.jpg",
    cta: "SHOP NOW",
    href: "/superstar",
},
{
    title: "Ways To Avoid Exercise Burnout",
    subtitle: "",
    description: "Feeling over the workout before even starting? Learn the signs of gym burnout and how to avoid it so you can get back to enjoying your training.",
    image: "/assets/resource/exercise_burnout_hero_d_215_994975_77b7589ad2.gif",
    cta: "SHOP NOW",
    href: "/superstar",
},
{
    title: "Let's Lunge: How To Properly Do A Lunge",
    subtitle: "",
    description: "Show your legs some love by learning how to properly do a lunge, plus three other lunge variations for a strong lower body.",
    image: "/assets/resource/how_to_do_a_lunge_mh_d_221_1036927_d975f2a9e6.jpg",
    cta: "SHOP NOW",
    href: "/superstar",
},
{
    title: "How To Lace Running Shoes",
    subtitle: "",
    description: "Whether you have wide feet, numb toes, or a heel that lifts with every step, learn how to tie running shoes to alleviate these common running shoe issues.",
    image: "/assets/resource/how_to_lace_running_shoes_mh_d_221_1061995_ea34f6b109.jpg",
    cta: "SHOP NOW",
    href: "/superstar",
},
//3
]
